export class AdminResetUserPasswordPayload {}